import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { MbTextField } from '../../../../components/MbTextFields';
import useAppInfo from '../../../../hooks/appInfo.hook';
import { appPublishStatus } from '../../../../utils/constants';

export default function GoogleAccount({ errors, register }) {
  const { appInfo } = useAppInfo()
  const isRequired = appInfo.androidPublishStatus !== appPublishStatus.FIRST_PUBLISH_PENDING;

  return (
    <Box mb={6}>
      <Typography variant="h5" mb={2}>
        Conta de desenvolvedor Google
      </Typography>

      <Grid
        container
        component="form"
        spacing={2}
        direction={'row'}
      >
        <Grid item xs={12} sm={12}>
          <Grid item xs={12} sm={12}>
            <MbTextField
              error={errors.developerAccountName?.message}
              label="Nome da conta de desenvolvedor Google"
              register={register("developerAccountName", {
                required: isRequired && "O nome da sua conta de desenvolvedor Google é obrigatório."
              })}
            />
          </Grid>

          <MbTextField
            error={errors.developerAccountEmail?.message}
            label="E-mail de conta de desenvolvedor Google"
            register={register("developerAccountEmail", {
              required: isRequired && "O e-mail da sua conta de desenvolvedor Google é obrigatório.",
              pattern: {
                value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}|s$/,
                message: "O e-mail não é válido."
              }
            })}
            type="email"
          />
        </Grid>
      </Grid>
    </Box>
  );
}